import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const cellStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.1875rem;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.semibold};
	color: ${theme.colors.ink};
`;

const mutedStyle = css`
	font-style: italic;
	font-weight: ${theme.fontWeights.medium};
	color: ${theme.colors.inkMuted};
`;

const detailStyle = css`
	font-size: ${theme.fontSizes.small};
	font-weight: ${theme.fontWeights.normal};
	font-style: normal;
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly title: string;
	readonly detail?: string | null;
	/** A deleted or unattributed object: italic, muted. */
	readonly isMuted?: boolean;
};

/** The left-aligned name of a row, with the line that qualifies it. */
const NameCell: React.FC<Props> = ({ title, detail = null, isMuted = false }) => {
	return (
		<span css={cellStyle}>
			<span css={isMuted ? mutedStyle : undefined}>{title}</span>
			<ConditionalLoader data={detail}>
				{(text) => <span css={detailStyle}>{text}</span>}
			</ConditionalLoader>
		</span>
	);
};

export default NameCell;
